import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

export const PrimeNgCustomPreset = definePreset(Aura, {
  components: {
    menu: {
      root: {
        background: 'var(--color-primaryBackground)',
        borderColor: 'var(--color-borderColor)',
        borderRadius: '16px',
        shadow: 'var(--shadow-mediumElevation)',
      },
      list: {
        padding: '0px',
        gap: '4px',
      },
      item: {
        color: 'var(--color-primaryLabel)',
        padding: '8px 12px',
        gap: '8px',
        borderRadius: '8px',
        focusBackground: 'var(--color-secondaryBackground)',
        focusColor: 'var(--color-primaryLabel)',
        icon: {
          color: 'var(--color-primaryIcon)',
          focusColor: 'var(--color-primaryIcon)',
        },
      },
      separator: {
        borderColor: 'var(--color-borderColor)',
      },
    },
    drawer: {
      root: {
        background: 'var(--grey-500)',
        borderColor: 'var(--color-borderColor)',
      },
      header: {
        padding: '0px',
      },
      content: {
        padding: '0px',
      },
      footer: {
        padding: '0px',
      },
    },
    chart: {
      root: {
        width: '360px',
        height: '360px',

      }
    },
    multiselect: {
      chip: {
        borderRadius: 'var(--radius-2)'
      },
      root: {
        borderColor: 'var(--grey-600)',
        focusBorderColor: 'var(--color-multiSelectBorderColor)',
        paddingY: 'var(--spacing-3)',
        borderRadius: 'var(--radius-4)',
      },
      option: {
        color: 'var(--color-primaryLabel)',
        focusColor: 'var(--color-primaryLabel)',
        focusBackground: 'var(--color-multiSelectfocusBackground)',
        selectedFocusBackground: 'var(--color-multiSelectBacground)',
        selectedFocusColor: 'var(--color-multiSelectselectedFocusColor)',
        selectedBackground: 'none',
        selectedColor: 'var(--color-primaryLabel)'
      }
    },

    dialog: {
      root: {
        borderRadius: 'var(--radius-12)',
      },
      header: {
        padding: 'none',
      },
      content: {
        padding: 'var(--spacing-5) var(--spacing-7)',
      },
      footer: {
        padding: 'var(--spacing-4) var(--spacing-7)',
      },
    },
    // New Design Select Component
    select: {
      root: {
        borderRadius: 'var(--radius-4)',
        borderColor: 'var(--color-inputBorder)',
        background: 'var(--color-inputBackground)',
        color: 'var(--color-inputValueTextColor)',
        paddingX: 'var(--spacing-4)',
        paddingY: 'var(--spacing-2-5)',
        hoverBorderColor: 'var(--color-inputBorder)',
        focusBorderColor: 'var(--color-inputFocusBorder)',
        invalidBorderColor: 'var(--color-inputInvalidBorder)',
        disabledBackground: 'var(--color-inputBackground)',
        disabledColor: 'var(--color-inputValueTextColor)',
        lg: {
          fontSize: '1rem',
        }
      },
      dropdown: {
        color: 'var(--color-selectDropdownIconColor)',
      },
      option: {
        color: 'var(--color-bodyText)',
        focusColor: 'var(--color-bodyText)',
        focusBackground: 'var(--color-selectOptionSlectedBackground)',
        selectedFocusBackground: 'var(--color-selectOptionSlectedBackground)',
        selectedFocusColor: 'var(--color-bodyText)',
        selectedBackground: 'var(--color-selectOptionBackground)',
        selectedColor: 'var(--color-bodyText)',
        padding: 'var(--spacing-3) var(--spacing-4)',
      },
      overlay: {
        background: 'var(--color-selectOptionBackground)',
        borderRadius: 'var(--radius-12)',
      },
      list: {
        gap: '0',
      },
    },

    /**
     * Tabs (PrimeNG)
     * Keep supported styling here; non-supported layout overrides live in bettaAlpha-components.css.
     */
    tabs: {
      tablist: {
        background: 'transparent',
        borderWidth: '0',
        borderColor: 'transparent',
      },
      tab: {
        background: 'var(--grey-500)', // #F6F7FA
        activeBackground: 'var(--static-white)', // #FFFFFF
        hoverBackground: 'var(--grey-500)',
        borderWidth: '0',
        borderColor: 'transparent',
        hoverBorderColor: 'transparent',
        activeBorderColor: 'transparent',
        color: 'var(--color-headingText)',
        hoverColor: 'var(--color-headingText)',
        activeColor: 'var(--color-headingText)',
        padding: 'var(--spacing-1) var(--spacing-5)', // 4px 20px
        fontWeight: 'var(--text-label-medium-b--font-weight)',
        gap: 'var(--spacing-1-5)', // 6px
        margin: '0',
        focusRing: {
          width: '0',
          style: 'none',
          color: 'transparent',
          offset: '0',
          shadow: 'none',
        },
      },
      activeBar: {
        height: '0px',
        background: 'transparent',
      },
      tabpanel: {
        background: 'transparent',
        color: 'var(--color-headingText)',
        padding: '0',
      },
    },
    // New Design Radio Button Component
    radiobutton: {
      root: {
        width: 'var(--spacing-5)',
        height: 'var(--spacing-5)',
        background: 'var(--color-radioBackground)',
        checkedBackground: 'var(--color-radioBackground)',
        checkedHoverBackground: 'var(--color-radioBackground)',
        borderColor: 'var(--color-radioBorder)',
        hoverBorderColor: 'var(--color-radioBorder)',
        checkedBorderColor: 'var(--color-radioBorder)',
        checkedHoverBorderColor: 'var(--color-radioBorder)',
      },
      icon: {
        checkedColor: 'var(--color-radioCheckedIconColor)',
        checkedHoverColor: 'var(--color-radioCheckedIconColor)',
        size: 'var(--spacing-3)',
      },
    },
    // New Design Radio Button Component
    floatlabel: {
      root: {
        invalidColor: 'var(--color-floatInvalidLabel)',
        focusColor: 'var(--color-floatFocusLabel)',
        color: 'var(--color-floatLabel)',
        activeColor: 'var(--color-floatFocusLabel)',
      },
    },
    // inputnumber: {
    //   root: {
    //     // @ts-expect-error - borderRadius is valid in PrimeNG theme API
    //     borderRadius: '0.5rem',
    //     borderColor: 'var(--ng-300)',
    //     background: 'var(--ng-50)',
    //     color: 'var(--ng-900)',
    //     fontSize: '0.875rem',
    //     padding: '0.75rem',
    //     focusBorderColor: 'var(--brand-primary-dark)',
    //     focusRing: {
    //       shadow: '0 0 0 2px rgba(0, 154, 120, 0.1)',
    //     },
    //   },
    // },
    // New Design Input Text Component
    textarea: {
      root: {
        borderRadius: 'var(--radius-4)',
        borderColor: 'var(--color-inputBorder)',
        hoverBorderColor: 'var(--color-inputBorder)',
        focusBorderColor: 'var(--color-inputFocusBorder)',
        invalidBorderColor: 'var(--color-inputInvalidBorder)',
        background: 'var(--color-inputBackground)',
        disabledBackground: 'var(--color-inputBackground)',
        color: 'var(--color-inputValueTextColor)',
        disabledColor: 'var(--color-inputValueTextColor)',
        paddingX: 'var(--spacing-4)',
        paddingY: 'var(--spacing-2-5)',
      },
    },
    // New Design Input Text Component
    inputtext: {
      root: {
        borderRadius: 'var(--radius-4)',
        borderColor: 'var(--color-inputBorder)',
        hoverBorderColor: 'var(--color-inputBorder)',
        focusBorderColor: 'var(--color-inputFocusBorder)',
        invalidBorderColor: 'var(--color-inputInvalidBorder)',
        background: 'var(--color-inputBackground)',
        disabledBackground: 'var(--color-inputBackground)',
        color: 'var(--color-inputValueTextColor)',
        disabledColor: 'var(--color-inputValueTextColor)',
        paddingX: 'var(--spacing-4)',
        paddingY: 'var(--spacing-2-5)',
      },
    },
    // New Design Button Component
    button: {
      root: {
        borderRadius: 'var(--radius-12)',
        paddingX: 'var(--spacing-2)',
        paddingY: 'var(--spacing-2)',
        // @ts-expect-error - fontSize is valid in PrimeNG theme API
        fontSize: 'var(--text-link-medium)',
        fontWeight: 'var(--text-link-medium--font-weight)',
        transition: 'all 0.2s',
        gap: 'var(--spacing-2)',
        iconOnlyWidth: "24px",
        lg: {
          paddingX: 'var(--spacing-2)',
          paddingY: 'var(--spacing-2)',
          fontSize: 'var(--text-link-medium)',
          iconOnlyWidth: "24px",
        },
        sm: {
          paddingX: 'var(--spacing-2)',
          paddingY: 'var(--spacing-2)',
          fontSize: 'var(--text-link-small)',
          iconOnlyWidth: "16px"
        }
      },
      colorScheme: {
        light: {
          root: {
            primary: {
              // new design - for primary button
              background: 'var(--color-primaryButtonBackground)',
              borderColor: 'var(--color-PrimaryButtonBorder)',
              activeBackground: 'var(--color-primaryButtonBackground)',
              hoverBackground: 'var(--color-primaryButtonBackground)',
              hoverBorderColor: 'var(--color-PrimaryButtonBorder)',
              color: 'var(--color-primaryButtonContent)',
              hoverColor: 'var(--color-primaryButtonContent)',
            },
            // @ts-expect-error - outlined variant is valid in PrimeNG but types are incomplete
            outlined: {
              // new design - for outlined button
              primary: {
                background: 'var(--color-primaryButtonOutlinedBackground)',
                color: 'var(--color-primaryOutlinedButtonContent)',
                borderColor: 'var(--color-primaryOutlinedButtonBorder)',
                activeBackground: 'var(--color-primaryOutlinedButtonHoverBackground)',
                activeColor: 'var(--color-primaryOutlinedButtonHoverContent)',
                hoverBackground: 'var(--color-primaryOutlinedButtonHoverBackground)',
                hoverBorderColor: 'var(--color-borderPrimaryOutlinedButtonHover)',
                hoverColor: 'var(--color-primaryOutlinedButtonHoverContent)',
              },
            },
            text: {
              // new design - for outlined button
              primary: {
                background: 'var(--color-primaryButtonOutlinedBackground)',
                color: 'var(--color-primaryOutlinedButtonContent)',
                borderColor: 'var(--color-primaryOutlinedButtonBorder)',
                activeBackground: 'var(--color-primaryOutlinedButtonHoverBackground)',
                activeColor: 'var(--color-primaryOutlinedButtonHoverContent)',
                hoverBackground: 'var(--color-primaryOutlinedButtonHoverBackground)',
                hoverBorderColor: 'var(--color-borderPrimaryOutlinedButtonHover)',
                hoverColor: 'var(--color-primaryOutlinedButtonHoverContent)',
              },
            },
          },
        },
      },
    },
    // New Design Checkbox Component
    checkbox: {
      root: {
        width: '20px',
        height: '20px',
        borderRadius: 'var(--radius-4)',
        borderColor: 'var(--color-checkboxBorder)',
        hoverBorderColor: 'var(--color-checkboxBorder)',
        checkedBorderColor: 'var(--color-checkboxBorder)',
        checkedHoverBorderColor: 'var(--color-checkboxBorder)',
        checkedBackground: 'var(--color-checkboxBackground)',
        checkedHoverBackground: 'var(--color-checkboxBackground)',
      },
      icon: {
        checkedColor: 'var(--color-checkboxIconColor)',
      },
    },
    // New Design Toggle Switch Component
    toggleswitch: {
      root: {
        width: '40px',
        height: '25px',
        borderRadius: 'var(--radius-12)',
      },
      handle: {
        size: '20px',
        borderRadius: 'var(--radius-full)',
      }
    },
    // New Design Card Component
    card: {
      root: {
        background: 'var(--color-whiteBackground)',
        borderRadius: 'var(--radius-12)',
        color: 'var(--color-primaryLabel)',
        shadow: 'var(--shadow-xsmall)',
      },
      body: {
        padding: 'var(--spacing-2-5)',
      },
    },
    // New Design Tag Component
    tag: {
      root: {
        padding: 'var(--spacing-1) var(--spacing-3)',
        gap: 'var(--spacing-2-5)',
        fontSize: 'var(--text-label-small-b)',
        fontWeight: 'var(--text-label-small-b--font-weight)',
        borderRadius: 'var(--radius-12)',
        roundedBorderRadius: 'var(--radius-full)',
      },
    },
    // New Design Progress Bar Component 
    progressbar: {
      root: {
        borderRadius: 'var(--radius-4)',
        height: '26px',
        background: 'var(--color-progressBarEmptyBackground)',
      },
      value: {
        background: 'var(--color-progressBarBackground)',
      },
      label: {
        fontSize: 'var(--text-label-small-b)',
        fontWeight: 'var(--text-label-small-b--font-weight)',
        color: 'var(--color-progressBarText)',
      },
    },
    // New Design Divider Component
    divider: {
      root: {
        borderColor: 'var(--color-dividerBorder)',
      },
      content: {
        color: 'var(--color-dividertextColor)',
      },
    },
    // Note: Stepper styling is handled in bettaAlpha-components.css
    // as PrimeNG stepper theme API doesn't support all required properties
    // New Design Accordion Component
    accordion: {
      header: {
        color: 'var(--color-accordionHeaderColor)',
        background: 'var(--color-accordionHeaderBackground)',
        // @ts-expect-error - fontSize is supported in PrimeNG preset objects
        fontSize: 'var(--text-subheading-medium)',
        fontWeight: 'var(--text-subheading-medium--font-weight)',
      },
      content: {
        color: 'var(--color-accordionContentColor)',
      }
    },

    paginator: {
      root: {
        background: 'var(--color-paginatorBackground)',
        padding: 'var(--spacing-6) 0 0 0',
        gap: '0'
      },
      navButton: {
        background: 'var(--color-paginatorNavButtonBackground)',
        hoverBackground: 'var(--color-paginatorNavButtonSelectedBackground)',
        selectedBackground: 'var(--color-paginatorNavButtonSelectedBackground)',
        color: 'var(--color-paginatorNavButtonText)',
        hoverColor: 'var(--color-paginatorNavButtonText)',
        selectedColor: 'var(--color-paginatorText)',
        width: 'var(--spacing-12)',
        height: 'var(--spacing-12)',
        borderRadius: '0',
      },
    },
    // New Design Table Component
    datatable: {
      root: {
        borderColor: 'var(--color-tableBorder)',
      },
      header: {
        background: 'var(--color-tableHeaderBackground)',
        borderColor: 'var(--color-tableBorder)',
        padding: 'var(--spacing-4)',
      },
      headerCell: {
        borderColor: 'var(--color-primaryBorder)',
        background: 'var(--color-tableHeaderBackground)',
        gap: 'var(--spacing-4)',
        padding: 'var(--spacing-4)',
        color: 'var(--color-tableHeaderText)',
      },
      bodyCell: {
        borderColor: 'var(--color-tableBodyBorder)',
        padding: 'var(--spacing-4)',
      },
      row: {
        hoverBackground: 'var(--color-tableHeaderBackground)',
        selectedBackground: 'var(--color-tableHeaderBackground)',
      },
    },

    popover: {
      root: {
        background: 'var(--color-popoverBackground)',
        borderRadius: 'var(--radius-12)',
        shadow: 'var(--shadow-mediumElevation)',
        // padding: '0',
      },
      content: {
        padding: 'var(--spacing-5) var(--spacing-4)',
      },
    },
    avatar: {
      root: {
        background: 'var(--color-avatarBackground)',
        color: 'var(--color-avatarText)',
        fontSize: 'var(--text-subheading-large)',
      },
    },
    autocomplete: {
      root: {
        focusBorderColor: 'var(--color-autocompleteBorderColor)'
      },
      option: {
        selectedBackground: 'var(--color-autocompleteSelectedBackground)',
        selectedColor: 'var(--color-autocompleteSelectedColor)'
      }
    },
    tree: {
      root: {
        padding: 'var(--spacing-4) var(--spacing-2) ',
      },
      node: {
        color: 'var(--color-headingText)',
        selectedColor: 'var(--color-headingText)',
        selectedBackground: 'var(--color-treeSelectedBackground)',
        hoverBackground: 'var(--color-treeHoverBackground)',
      },
      nodeToggleButton: {
        selectedHoverColor: 'var(--color-headingText)',
      }
    },
    tooltip: {
      root: {
        borderRadius: 'var(--radius-4)',
      }
    },
    badge:{
      root: {
        borderRadius: 'var(--radius-full)',
        padding: '0px',
      }
    }
  },
});
